import React, { useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';

import { FormContext } from '../../hooks/useForm';
import FormWrapper from '../FormWrapper';
import Column from '../../helpers/columns';
import useDatasource from '../../hooks/useDatasource';
import { getProductGroups } from '../../services/offers/product-groups';
import { NominalTypes } from './OffersConstants';

const ProductGroupsGrid = ({ canEdit = true }) => {
  const { t } = useTranslation();

  const form = useContext(FormContext);

  const { value, setValue, errorMessages } = form;

  const { productGroups } = value;

  const columns = useMemo(
    () => [
      Column.text('name', t('entity.offers.productGroup.name._')),
      Column.text('price', t('entity.offers.productGroup.price')),
      Column.dictionary(
        'nominalType',
        t('entity.offers.productGroup.nominalType._'),
        NominalTypes,
        {
          width: 150,
          dictLabel: (entry) =>
            t(`entity.offers.productGroup.nominalType.${entry.id}`),
        },
      ),
    ],
    [t],
  );

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys: productGroups,
      onSelect: (record, selected) =>
        selected
          ? setValue('productGroups', [...productGroups, record.id])
          : setValue(
              'productGroups',
              productGroups.filter((id) => id !== record.id),
            ),
      getCheckboxProps: ({ deleted, id }) => ({
        disabled: deleted && !productGroups.some((pgId) => pgId === id),
      }),
    }),
    [productGroups, setValue],
  );

  const { pagination, content, handleChange } = useDatasource(getProductGroups);

  return (
    <>
      <FormWrapper.ErrorMessage message={errorMessages?.productGroups} />
      <Table
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
          getCheckboxProps: () => ({
            disabled: !canEdit,
          }),
        }}
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
      />
    </>
  );
};

export default ProductGroupsGrid;
